var _g, _line, _g2, _g3, _rect, _rect2, _g4, _rect3, _rect4, _line2, _line3, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNewFrameSizeArcFa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "554.9px",
    height: "624.4px",
    viewBox: "0 0 554.9 624.4",
    enableBackground: "new 0 0 554.9 624.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M488.7,608c-0.8,0-1.5-0.2-2.1-0.5c0,0.4,0,0.9,0,1.3s-0.1,0.9-0.3,1.4c-0.2,0.5-0.4,1-0.7,1.5 c-0.3,0.4-0.7,0.8-1.2,1.1c-0.5,0.4-1.1,0.6-1.8,0.8c-0.7,0.2-1.4,0.3-2.3,0.4h-0.4c-0.8,0-1.5-0.1-2.1-0.3s-1.2-0.5-1.7-1 c-0.4-0.4-0.8-0.9-1.1-1.4s-0.5-1.1-0.6-1.8c0-0.4-0.1-0.7-0.1-1.1s0-0.7,0.1-1s0.1-0.6,0.2-0.9c0.1-0.3,0.1-0.6,0.2-0.8 c0.2-0.6,0.4-1.1,0.6-1.5c0.2-0.4,0.4-0.7,0.5-0.9l1.4,1c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.2-0.2,0.4-0.3,0.7s-0.2,0.5-0.3,0.9 s-0.2,0.6-0.2,1c-0.1,0.3-0.1,0.7-0.1,1c0,0.4,0,0.7,0.1,1c0,0.2,0.1,0.3,0.1,0.5c0.1,0.2,0.1,0.4,0.3,0.6s0.3,0.4,0.4,0.7 c0.2,0.2,0.4,0.4,0.7,0.6c0.3,0.2,0.6,0.3,1,0.4c0.4,0.1,0.8,0.2,1.3,0.2h0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c1.2-0.1,2.2-0.3,3-0.7c0.8-0.4,1.3-1,1.5-1.8c0.2-0.5,0.2-1,0.2-1.5c0-0.5,0-1-0.1-1.4s-0.2-0.9-0.3-1.3 c-0.1-0.4-0.3-0.7-0.4-1.1c-0.1-0.1-0.1-0.2-0.2-0.4s-0.1-0.2-0.2-0.4c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1l1.5-0.9 c0,0,0.1,0.1,0.2,0.3c0.1,0.2,0.3,0.5,0.4,0.8c0.3,0.6,0.6,1.1,0.9,1.4c0.3,0.4,0.5,0.6,0.8,0.8c0.3,0.2,0.5,0.3,0.7,0.3 c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6C489.2,607.9,489,608,488.7,608z  M482,603l-1.4,1.4l-1.4-1.4l1.4-1.4L482,603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M487.8,607.2c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2h0.7c0.5,0,1,0,1.4-0.1 c0.4-0.1,0.8-0.2,1.2-0.3c0.3-0.2,0.6-0.4,0.8-0.6s0.3-0.6,0.3-1c0-0.3,0-0.7-0.1-1c0-0.3-0.1-0.7-0.3-1.2l1.6-0.5 c0.1,0.2,0.1,0.4,0.1,0.6s0.1,0.5,0.1,0.7c0,0.2,0.1,0.5,0.1,0.7c0,0.2,0,0.5,0.1,0.7c0,0.2,0,0.4,0.1,0.7c0,0.2,0.1,0.5,0.2,0.7 c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1,0,0.2-0.1,0.3 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0-1.1-0.1-1.5-0.3c-0.4-0.2-0.7-0.5-0.9-0.8 c-0.2,0.2-0.5,0.4-0.8,0.5s-0.7,0.3-1.1,0.3c-0.4,0.1-0.8,0.2-1.2,0.2c-0.4,0-0.9,0.1-1.3,0.1h-0.7c-0.2,0-0.4-0.1-0.6-0.2 C487.9,607.6,487.8,607.4,487.8,607.2z M491.4,611.3l-1.4,1.4l-1.4-1.4l1.4-1.4L491.4,611.3z M495,611.3l-1.4,1.4l-1.4-1.4 l1.4-1.4L495,611.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M495.4,607.2c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.3h0c0.5,0,0.9-0.1,1.2-0.2 c0.3-0.2,0.6-0.4,0.9-0.6c0.2-0.3,0.5-0.6,0.7-0.9c0.2-0.3,0.4-0.7,0.5-1c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.3-0.5,0.5-0.8 c0.5-0.6,1.2-1,1.9-1c0.9,0,1.6,0.4,2.2,1.1c0.5,0.6,0.7,1.3,0.8,2.1c0.1,0.4,0.1,0.8,0,1.2c0,0.4-0.1,0.7-0.3,1.1 c-0.2,0.4-0.4,0.8-0.7,1c-0.3,0.3-0.6,0.5-1,0.6c-0.6,0.2-1.4,0.1-2.2-0.2c-0.6-0.2-1.2-0.6-1.8-1c0,0-0.1,0.1-0.1,0.1 c-0.9,0.9-2,1.3-3.3,1.3h0c-0.2,0-0.4-0.1-0.6-0.2C495.5,607.6,495.4,607.4,495.4,607.2z M500.6,605.2c0.5,0.4,1,0.7,1.4,0.8 c0.4,0.2,0.8,0.2,1.1,0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.3,0.2-0.4c0.1-0.2,0.1-0.4,0.1-0.6s0-0.5,0-0.7c0,0,0-0.1,0-0.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.4s-0.2-0.2-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.3-0.3,0.5c-0.1,0.2-0.2,0.5-0.4,0.7L500.6,605.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M510.6,602.4c0.2,0.5,0.3,1.1,0.5,1.6c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.1,0.5,0.2,0.7 c0.1,0.2,0.1,0.5,0.1,0.7c0,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.5-0.1,1-0.2,1.5 c-0.1,0.5-0.4,0.9-0.6,1.4c-0.3,0.4-0.6,0.9-0.9,1.3c-0.4,0.4-0.8,0.8-1.2,1.1c-0.4,0.4-0.9,0.7-1.3,1c-0.5,0.3-1,0.6-1.4,0.8 l-0.8-1.5c0.6-0.3,1.2-0.7,1.8-1c0.6-0.4,1.1-0.8,1.5-1.3c0.4-0.5,0.8-1,1.1-1.5c0.3-0.5,0.4-1.1,0.4-1.6c0,0,0-0.1,0-0.1 c0-0.1,0-0.1,0-0.2v0c0-0.2,0-0.4-0.1-0.6c0-0.2-0.1-0.4-0.1-0.7s-0.1-0.4-0.2-0.7c-0.1-0.2-0.1-0.4-0.2-0.6 c-0.1-0.5-0.3-1-0.4-1.5L510.6,602.4z M511,598.8l-1.4,1.4l-1.4-1.4l1.4-1.4L511,598.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M535.3,605.9C535.2,605.9,535.2,606,535.3,605.9c-0.1,0.1-0.1,0.2-0.2,0.2c0.4,0.1,0.7,0.1,1.1,0.2 c0.4,0,0.7,0.1,1.1,0.1c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2s-0.2,0.1-0.3,0.1c-0.7,0-1.5-0.1-2.2-0.2c-0.7-0.1-1.3-0.3-1.9-0.5c-0.1,0-0.2,0.1-0.3,0.1 s-0.2,0.1-0.3,0.1c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.3,0.2c-0.5,0.1-1,0.1-1.5,0.1c-0.5,0-1,0-1.6,0 c-1.8,0-3.2-0.2-4.4-0.7c-1.2-0.4-2-1.1-2.5-2c-0.2-0.4-0.4-0.8-0.5-1.2c-0.1-0.4-0.1-0.8-0.1-1.2c0-0.4,0.1-0.7,0.1-1.1 c0.1-0.3,0.2-0.6,0.3-0.9s0.2-0.5,0.3-0.6c0.1-0.2,0.1-0.3,0.1-0.3l1.5,0.8c0,0,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.3-0.2,0.4 c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.3,0,0.5,0,0.8s0.1,0.5,0.3,0.8c0.2,0.3,0.4,0.5,0.7,0.8 c0.3,0.2,0.6,0.4,1,0.6c0.4,0.1,0.9,0.3,1.4,0.3c0.5,0.1,1.2,0.1,1.9,0.1c0.5,0,1,0,1.4,0c0.4,0,0.8,0,1.1-0.1 c0.3,0,0.6-0.1,0.9-0.1c0.3,0,0.5-0.1,0.7-0.1c-0.8-0.7-1.2-1.4-1.2-2.3c0-0.5,0.1-1.1,0.2-1.5c0.2-0.5,0.4-0.9,0.7-1.3 c0.3-0.4,0.7-0.7,1.1-0.9c0.4-0.2,0.8-0.3,1.3-0.3c0.4,0,0.8,0.1,1.1,0.2s0.7,0.4,0.9,0.6c0.1,0.1,0.2,0.2,0.3,0.4 c0.1,0.2,0.2,0.3,0.3,0.6c0.1,0.2,0.2,0.5,0.2,0.7s0.1,0.6,0.1,0.9C536,604.4,535.8,605.2,535.3,605.9z M533.1,605.5 c0.2-0.1,0.5-0.3,0.6-0.5c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.4,0.2-0.6c0-0.2,0-0.4,0-0.6c0-0.4-0.1-0.7-0.2-1 c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0.1-0.4,0.3-0.5,0.5 c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.3-0.2,0.6-0.2,1c0,0.3,0.1,0.5,0.4,0.8c0.3,0.3,0.6,0.5,1.1,0.7L533.1,605.5z M534.5,596.4 l-1.4,1.4l-1.4-1.4l1.4-1.4L534.5,596.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M536.4,607.2c0-0.2,0.1-0.4,0.3-0.6s0.4-0.2,0.7-0.2h0.9c0.3,0,0.7,0,1.1,0s0.7,0,1.1-0.1s0.7-0.2,0.9-0.3 c0.3-0.1,0.5-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9c0-0.3,0-0.7-0.1-1.1c-0.1-0.2-0.2-0.5-0.5-0.9s-0.6-0.8-0.9-1.2 s-0.8-0.9-1.2-1.3c-0.5-0.4-0.9-0.9-1.4-1.2l0.2-1.8l7.1-3.1l0.7,1.6L540,598c0.3,0.2,0.6,0.5,0.9,0.8s0.7,0.6,1,1 c0.4,0.5,0.8,1,1.1,1.4s0.5,0.9,0.7,1.3c0.2,0.4,0.3,0.8,0.3,1.1c0.1,0.4,0.1,0.7,0,1s-0.1,0.6-0.2,0.9s-0.2,0.5-0.3,0.7 c-0.5,0.9-1.4,1.5-2.6,1.7c-0.2,0-0.5,0.1-0.8,0.1h-2.8c-0.3,0-0.5-0.1-0.7-0.2C536.5,607.6,536.4,607.4,536.4,607.2z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 8.3,
    y1: 606.1,
    x2: 468.3,
    y2: 606.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 141.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.3,
    y: 164.2,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.6,
    y: 47.6,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 413.6,
    y: 44.6,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 44.6,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 399.2,
    y1: 85.2,
    x2: 76.8,
    y2: 85.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "396.5,76.2 412.1,85.2 396.5,94.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "79.4,76.2 63.9,85.2 79.4,94.2  "
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 389.1,
    y: 34.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4,
    y: 34.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 413.6,
    y1: 54.5,
    x2: 413.6,
    y2: 95.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6287,
    x1: 62.9,
    y1: 54.5,
    x2: 62.9,
    y2: 95.9
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 458.8,75.5 468.3,65.9 8.5,65.9 17.4,75.5 457.5,75.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 33.8,
    opacity: 0.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5848,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 460,
    height: 32.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNewFrameSizeArcFa);
export default __webpack_public_path__ + "static/media/help_new_FrameSize_arc_fa.bf91f11912f707483727a418da27a794.svg";
export { ForwardRef as ReactComponent };